/**
 * Event names for ScaVerify embedded component.
 * Use these when adding listeners so the APP can react to SCA outcomes.
 *
 * Listen on window or document, e.g.:
 *   window.addEventListener(SCA_VERIFY_EVENTS.SUCCESS, (e) => { ... e.detail });
 */

export const SCA_VERIFY_EVENTS = {
  /** Verification succeeded. detail: { token } */
  SUCCESS: "sca-verify:success",
  /** Verification failed. detail: { reason } */
  FAILED: "sca-verify:failed",
  /** SCA error (init or runtime). detail: error object */
  ERROR: "sca-verify:error",
  /** User cancelled. detail: event */
  CANCEL: "sca-verify:cancel",
  /** Component ready. detail: {} */
  READY: "sca-verify:ready",
  /** SCA setup succeeded (e.g. first-time setup). detail: { mobileInfo } */
  SCA_SETUP_SUCCEED: "sca-verify:scaSetupSucceed",
};

/**
 * Dispatch a custom event on window for the host (web or WebView) to listen.
 */
export function dispatchScaVerifyEvent(eventName, detail = {}) {
  if (typeof window === "undefined" || !window.dispatchEvent) return;
  const event = new CustomEvent(eventName, { detail, bubbles: true });
  window.dispatchEvent(event);
}
